import React from 'react';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Select } from '../inspinia';
import Pagination from 'react-js-pagination';
import { withRouter } from 'react-router-dom';

//MASK
import InputMask from 'react-input-mask';

//HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

class AgendamentoUpload extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            form: {
                dataInicio: "",
                dataFim: "",
                filial: { id: 0, nome:'' },
                status: ""
            },
            rotinaDisabled: false,
            list:
            {
                currentPage: 0, pageNumber: 0, size: 0, totalElements: 0, content: undefined
            },
            comboStatus:
            {
                results: undefined
            },
            comboEmpresa:
            {
                results: undefined
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleBuscar = this.handleBuscar.bind(this);
        this.handleChangeEmpresa = this.handleChangeEmpresa.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
    }

    resetarLista = () => {
        this.loadListaAgendamentoMailing(1);
      };

    handleChange(e) {
        const form = this.state.form;
        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleChangeEmpresa(e) {
        const form = this.state.form;
        this.setState({ form: { ...form, [e.target.name]: { id: e.target.value, nome: e.target.options[e.target.selectedIndex].text } } });
    }

    componentDidMount() {
        this.LoadComboEmpresa();
        this.LoadComboStatus();
        this.loadListaAgendamentoMailing();
    }

    LoadComboEmpresa() {
        const self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options = {
            method: 'POST',
            body: data
        };

        this.comboEmpresaSubscription = callApi(url, options, function (response) {
            self.setState({ ...self.state, comboEmpresa: response });
        });
    }

    LoadComboStatus() {
        self = this;

        const url = `${c.API_BASE_URL}/combo-status-agendamento-mailing`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, function (response) {

            if (response.results !== 'undefined' && response.results.length === 1) {

                self.setState({ ...self.state, comboStatus: response, form: { ...self.state.form, tipoListaContato: response.results[0].value } });

            } else {

                self.setState({ ...self.state, comboStatus: response });
            }

        });
    }

    limparFormulario() {
        const state = this.state;

        const select = document.querySelector('select');
        select.value = "Selecione...";

        this.setState({
            ...state,
            form: {
                dataInicio: "",
                dataFim: "",
                status: { id: 0 },
            },
            campanhaValues: {
                value: "",
                label: ""
            }
        })
    }

    handleBuscar(pageNumber) {
        const self = this;
        const state = self.state;
    
        const isNovaBusca = pageNumber === undefined;
        const page = isNovaBusca ? 0 : pageNumber - 1;
        const size = 10;
    
        self.setState({ ...state, loading: true });
    
        if (state.form.status === "Selecione...") {
            state.form.status = "";
        }
    
        if (isBlank(state.form.dataInicio)) {
            if (!isBlank(state.form.dataFim)) {
                c.TOASTER_INFO("Data Início precisa ser preenchida para efetuar a busca com Data Fim.");
                self.setState({ ...state, loading: false });
                return;
            } else {
                this.loadListaAgendamentoMailing();
                return;
            }
        }
    
        const url = `${c.API_BASE_URL}/buscarAgendamentoMailing?page=${page}&size=${size}`;
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                dataInicio: state.form.dataInicio,
                dataFim: state.form.dataFim,
                filial: state.form.filial.nome === "Selecione..." ? "" : state.form.filial.nome,
                status: state.form.status,
                idMailing: null
            })
        };
    
        callApi(url, options, function (response) {
            self.setState({
                ...self.state,
                list: response,
                loading: false,
                page: pageNumber || 1
            });
        });
    }
    
    loadListaAgendamentoMailing(pageNumber) {
        const self = this;
        const state = self.state;
    
        const isNovaBusca = pageNumber === undefined;
        const page = isNovaBusca ? 0 : pageNumber - 1;
        const size = 10;
    
        const url = `${c.API_BASE_URL}/listarMailings?page=${page}&size=${size}`;
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                dataInicio: null,
                dataFim: null,
                filial: state.form.filial.nome === "Selecione..." ? "" : state.form.filial.nome,
                status: state.form.status,
                idMailing: null
            })
        };
    
        callApi(url, options, (response) => {           
            this.setState({
              list: response,
              loading: false,
              page: isNovaBusca ? 1 : pageNumber         
            });
          });
    }    

    handlePageChange(pageNumber) {
        this.setState({ page: pageNumber });
    
        if (this.state.form.dataInicio === "" && this.state.form.dataFim === "") {
            this.loadListaAgendamentoMailing(pageNumber);
        } else {
            this.handleBuscar(pageNumber);
        }
    }         

    render() {
        return (

            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-0">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Status Upload Mailings</h3>
                            </Title>

                            <Content>
                                <Row>
                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Inicio:</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={this.state.form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Fim:</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={this.state.form.dataFim} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Empresa:</label>
                                        <Select name="filial" selected={this.state.form.filial.id} data={this.state.comboEmpresa} onChange={this.handleChangeEmpresa} placeholder="Filial" />
                                    </Column>

                                    <Column size="4" className="p-1 mx-auto container">
                                        <label for="status">Status Mailing</label>
                                        <Select name="status" selected={this.state.form.status} data={this.state.comboStatus} onChange={this.handleChange} placeholder="Status Mailing" />
                                    </Column>

                                    <Column size="auto" className="p-1 mx-auto container" style={{ top: "30px" }}>
                                        <div className="input-group" >
                                            <Button className="mx-1" onClick={this.handleBuscar} width="130px">Buscar</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>
                                        </div>
                                    </Column>

                                </Row>

                                <Row className="m-0 mb-3">

                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} loading={this.state.loading} resetarLista={this.resetarLista} />
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
                {/* FOOTER */}
                <Row className="mb-4">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
}

class Table extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            alerta: withReactContent(Swal),
            loading: false
        };
    }

    handlePopupErro(arquivo, msg, anexoFaltante) {
        if (anexoFaltante) {
            msg = '<strong>Arquivos Faltantes:</strong><br />' + msg
                + '<br /><br />' + 'Para confirmar o envio do mailing com arquivos faltantes, <br /> favor clicar no ícone de ações: '
                + '<br /><i class="fa fa-paper-plane text-info text-center"></i>';
        }
        this.state.alerta.fire({
            icon: 'error',
            title: 'Erro no upload do arquivo ' + arquivo,
            html: msg,
            confirmButtonColor: '#47A789',
        });
    }

    handlePopupCancelar(arquivo, msg, idMailing, mailing) {
            msg = '<strong>Arquivos Faltantes:</strong><br />' + msg +
                  '<br /><br />Para cancelar o envio do mailing com arquivos faltantes, <br /> ' +
                  'clique no botão abaixo: ' +
                  '<br /><button id="btnCancelar" class="swal2-confirm swal2-styled" style="background-color: #47A789; margin-top: 22px; padding: 8px 20px;">Cancelar Mailing</button>';
        
        
        this.state.alerta.fire({
            icon: 'error',
            title: 'Erro no upload do arquivo ' + arquivo,
            html: msg,
            showCloseButton: true,     
            showConfirmButton: false,  
            confirmButtonColor: '#47A789',
            didOpen: () => {
                const btnCancelar = document.getElementById('btnCancelar');
                if (btnCancelar) {
                    btnCancelar.addEventListener('click', () => {
                        this.handleCancelar(idMailing, mailing);
                        this.state.alerta.close();
                    });
                }
            }
        });
    }

    handleCancelar(idMailing, mailing) {
        const self = this;
        const state = self.state;
        self.setState({ ...state, loading: true });

        let url = `${c.API_BASE_URL}/toi-validate/cancelar/${idMailing}`;
        const options = {
            method: 'PATCH'
        };

        callApi(url, options, (resp) => {
            let isError = false;
            let titulo = "";
            let message = "";
            let icon = "";

            if (resp.status === 200) {
                message = resp.message;
            } else {
                isError = true;
                message = resp.message;
            }

            if (isError) {
                titulo = "Erro ao cancelar o envio de mailing";
                icon = "error"
            } else {
                titulo = "Mailing cancelado com sucesso!";
                icon = "success";
            }

            self.state.alerta.fire({
                icon: icon,
                title: titulo,
                html: message,
                confirmButtonColor: '#47A789',
            });

            this.props.resetarLista();
            this.setState({ loading: false });
        });
    }

    handlePopupConfirm(idMailing, mailing, idAgendamento, nomeFilial) {
        const self = this;
        const htmlContent = '<p>Para confirmar o envio do mailing <strong>' + mailing + '</strong>, favor clicar no botão abaixo:</p>' +
                    '<br /><button id="btnConfirmar" class="swal2-confirm swal2-styled" style="background-color: #47A789">Confirmar Envio</button>';

        this.state.alerta.fire({
            title: 'Confirmação de Mailing',
            html: htmlContent,
            icon: "warning",
            showCloseButton: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                document.getElementById('btnConfirmar').addEventListener('click', () => {
                    self.handleConfirmar(idMailing, mailing, idAgendamento, nomeFilial);
                    self.state.alerta.close();
                });
            }
        });
    }

    handleConfirmar(idMailing, mailing, idAgendamento, nomeFilial) {
        const self = this;
        const state = self.state;
        self.setState({ ...state, loading: true });

        let url = `${c.API_BASE_URL}/toi-validate/confirmar/${idMailing}/${idAgendamento}/${nomeFilial}`;
        const options = {
            method: 'GET'
        };

        callApi(url, options, (resp) => {
            let isError = false;
            let titulo = "";
            let message = "";
            let icon = "";

            if (resp.status === 200) {
                message = 'O mailing ' + mailing + ' foi confirmado. <br />Caso ocorra algum erro você será informado por e-mail!';
            } else {
                isError = true;
                message = resp.message;
            }

            if (isError) {
                titulo = "Erro ao confirmar envio de mailing";
                icon = "error"
            } else {
                titulo = "Envio de mailing confirmado com sucesso!";
                icon = "success";
            }

            self.state.alerta.fire({
                icon: icon,
                title: titulo,
                html: message,
                confirmButtonColor: '#47A789',
            });

            this.props.resetarLista();
            this.setState({ loading: false });
        });
    }

    render() {
        const loading = this.props.loading;
        const data = this.props.data;
        let html = "";

        if (loading) {
            html = (<tr><td colSpan="8" scope="row">Carregando Agendamentos...</td></tr>);
        }
        else if (data.length === 0 || data.content === undefined || data.content.length === 0) {
            html = (<tr><td colSpan="8" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length > 0) {
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td className="text-center" style={{ width: '70px' }}>{row.id}</td>
                    <td><div style={{ wordBreak: 'break-word', width: '275px' }}>{row.nome}</div></td>
                    <td className="text-center" style={{ width: '225px' }}>{ajustaData(row.dataSolicitacao)}</td>
                    <td className="text-center" style={{ width: '225px' }}>{row.dataProcessamento != null ? ajustaData(row.dataProcessamento) : "-"}</td>
                    <td className="text-center" style={{ width: '70px' }}>{row.nomeEmpresa}</td>
                    <td className="text-center" style={{ width: '70px' }}>{row.nomeFilial}</td>
                    <td className="text-center" style={{ width: '70px' }}>{row.status}</td>
                    <td className="text-center" style={{ width: '170px' }} >
                        <div style={{ display: (!this.state.loading ? 'flex' : 'none') }}>
                            <Button onClick={() => this.handlePopupErro(row.nome, row.mensagem, row.anexoFaltante)} disabled={row.status != 'Erro'} background='transparent' border='none' ><Icon name="fa-exclamation-triangle" className="mx-1 text-danger text-center" /></Button>
                            <Button onClick={() => this.handlePopupCancelar(row.nome, row.mensagem, row.idMailing, row.mailing)} disabled={!row.anexoFaltante} background='transparent' border='none' ><Icon name="fa-ban" className="mx-1 text-danger text-center" /></Button>
                            <Button onClick={() => this.handlePopupConfirm(row.idMailing, row.mailing, row.idAgendamento, row.nomeFilial)} disabled={!row.anexoFaltante} background='transparent' border='none' ><Icon name="fa-paper-plane" className="mx-1 text-info text-center" /></Button>
                        </div>
                        {this.state.loading && (
                            <CircularProgress
                                size={30}
                                thickness={4}
                                color='inherit'
                                variant='indeterminate' />
                        )}
                    </td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th className="text-center">#</th>
                        <th>Nome</th>
                        <th className="text-center">Data Solicitação</th>
                        <th className="text-center">Data Processamento</th>
                        <th className="text-center">Empresa</th>
                        <th className="text-center">Filial</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function ajustaData(str) {
    var splitDataHora = str.split(' ');
    var ano = splitDataHora[0].split('-')[0];
    var mes = splitDataHora[0].split('-')[1];
    var dia = splitDataHora[0].split('-')[2];


    return dia + "/" + mes + "/" + ano + " " + splitDataHora[1].split('.')[0];
}

function mapStateToProps(state) {
    return { auth: state.auth };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendamentoUpload));